import { Box, Skeleton, Stack, useMediaQuery, useTheme } from "@mui/material";
import { DealCardSkeleton } from "components";

const GRID_COLUMNS = {
  xs: "1fr",
  sm: "repeat(2, 1fr)",
  md: "repeat(3, 1fr)",
  lg: "repeat(4, 1fr)",
};

export function DealGridSkeleton({ showWeekButtons = false }) {
  const theme = useTheme();
  const isLg = useMediaQuery(theme.breakpoints.up("lg"));
  const isMd = useMediaQuery(theme.breakpoints.up("md"));
  const isSm = useMediaQuery(theme.breakpoints.up("sm"));

  const skeletonCount = isLg ? 4 : isMd ? 3 : isSm ? 2 : 1;

  return (
    <Box>
      {showWeekButtons && (
        <Box sx={{ width: "100%" }}>
          <Stack direction="row" alignItems="center" sx={{ pt: 2, pb: 2 }}>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(7, 1fr)",
                width: "100%",
                gap: 0,
              }}
            >
              {[...Array(7)].map((_, index) => (
                <Skeleton
                  key={index}
                  variant="rectangular"
                  height={36}
                  sx={{
                    borderRadius: 0,
                    "&:first-of-type": {
                      borderTopLeftRadius: 12,
                      borderBottomLeftRadius: 12,
                    },
                    "&:last-of-type": {
                      borderTopRightRadius: 12,
                      borderBottomRightRadius: 12,
                    },
                  }}
                />
              ))}
            </Box>
            <Skeleton variant="circular" width={40} height={40} sx={{ ml: 1 }} />
          </Stack>
        </Box>
      )}

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: GRID_COLUMNS,
          gap: 2,
          width: "100%",
          alignItems: "start",
        }}
      >
        {[...Array(skeletonCount)].map((_, index) => (
          <DealCardSkeleton key={index} showTimeTypography={showWeekButtons} />
        ))}
      </Box>
    </Box>
  );
}